import { ClassicEditor as ClassicEditorBase } from 'ckeditor5';
import {
	Essentials,
	Autoformat,
	Bold,
	Italic,
	BlockQuote,
	Heading,
	Link,
	AutoLink,
	List,
	Paragraph,
	Table,
	TableToolbar,
	TableProperties,
	TableCellProperties,
	TableCaption,
	TableColumnResize
} from 'ckeditor5';

class ClassicEditor extends ClassicEditorBase {
}

ClassicEditor.builtinPlugins = [
	Essentials,
	Autoformat,
	Bold,
	Italic,
	BlockQuote,
	Heading,
	Link,
	AutoLink,
	List,
	Paragraph,
	Table,
	TableToolbar,
	TableProperties,
	TableCellProperties,
	TableCaption,
	TableColumnResize
];

export default ClassicEditor;